import React from 'react';
import { TagsInput } from 'react-tag-input-component';
import { Card, CardBody, CardHeader, CardHeaderBtn } from './../../components/card/card.jsx';
import { Icon } from '@iconify/react';

function PagesScrumBoard() {
	var tags = ['enhancement'];
  
	return (
		<div>
			<div className="d-flex align-items-center mb-md-3 mb-2">
				<div className="flex-fill">
					<ul className="breadcrumb">
						<li className="breadcrumb-item"><a href="#/">PAGES</a></li>
						<li className="breadcrumb-item active">SCRUM BOARD</li>
					</ul>
			
					<h1 className="page-header mb-0">
						Scrum Board
					</h1>
				</div>
				<div className="ms-auto">
					<a href="#modalAddTask" data-bs-toggle="modal" className="btn btn-theme btn-sm py-2 fs-11px w-120px d-flex align-items-center justify-content-center">
						<Icon icon="material-symbols-light:add" className="fs-22px me-1 ms-n3 my-n3" />
						ADD TASK
					</a>
				</div>
			</div>
			
			<div className="mb-md-4 mb-3 d-md-flex">
				<div className="me-2">
					<a href="#/" data-bs-toggle="dropdown" className="text-body text-decoration-none d-flex align-items-center"><Icon icon="material-symbols-light:folder-outline-rounded" className="fs-20px opacity-5 me-2" /> project <b className="caret opacity-5 ms-3"></b></a>
					<div className="dropdown-menu">
						<a href="#/" className="dropdown-item"><i className="far fa-folder fa-fw me-1"></i> project/mobile-app-dev</a>
						<a href="#/" className="dropdown-item"><i className="far fa-folder fa-fw me-1"></i> project/bootstrap-5</a>
						<a href="#/" className="dropdown-item"><i className="far fa-folder fa-fw me-1"></i> project/mvc-version</a>
						<a href="#/" className="dropdown-item"><i className="far fa-folder fa-fw me-1"></i> project/ruby-version</a>
					</div>
				</div>
				<div className="ms-md-4 mt-md-0 mt-2 me-2 text-body d-flex align-items-center"><Icon icon="material-symbols-light:cable" className="fs-20px opacity-5 me-2" /> 1,392 pull request</div>
				<div className="ms-md-4 mt-md-0 mt-2 me-2 text-body  d-flex align-items-center"><Icon icon="material-symbols-light:settings-outline" className="fs-20px opacity-5 me-2" /> 52 participant</div>
				<div className="ms-md-4 mt-md-0 mt-2 me-2 text-body  d-flex align-items-center"><Icon icon="material-symbols-light:nest-clock-farsight-analog-outline" className="fs-20px opacity-5 me-2" /> 14 day(s)</div>
			</div>
			
			<div className="row gy-3 gx-3">
				<div className="col-xl-4 col-lg-6">
					<Card>
						<CardHeader className="with-btn">
							TO DO (5)
							<CardHeaderBtn />
						</CardHeader>
						<CardBody className="list-group list-group-flush p-0 text-white">
							<div className="list-group-item d-flex px-3 text-body">
								<div className="me-3">
									<i className="far fa-question-circle opacity-5 fa-fw fa-lg"></i> 
								</div>
								<div className="flex-fill">
									<div className="fw-semibold">Enable open search</div>
									<div className="small mb-2 opacity-75">#29949 opened yesterday by Terry</div>
									<div className="">
										<span className="badge bg-primary bg-opacity-10 text-primary border border-primary me-2">docs</span>
										<span className="badge bg-success bg-opacity-10 text-success border border-success me-2">feature</span>
									</div>
									<hr className="my-3" />
									<div className="d-flex align-items-center mb-2 small">
										<div className="fw-semibold me-2">
											Task (2/3)
										</div>
										<div className="flex-1">
											<a href="#/" className="text-body text-opacity-50" data-bs-toggle="collapse" data-bs-target="#todoBoard">
												<i className="bi bi-plus-square"></i>
											</a>
										</div>
										<div className="progress progress-xs w-100px me-3 h-4px">
											<div className="progress-bar progress-bar-striped" style={{ width: '66%' }}></div>
										</div>
										<div>66%</div>
									</div>
									<div className="form-group mb-0 pb-1 fs-11px text-body text-opacity-75">
										<div className="collapse show" id="todoBoard">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="customCheck1" defaultChecked />
												<label className="form-check-label mb-1px ps-1" htmlFor="customCheck1">create ui for autocomplete</label>
											</div>
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="customCheck2" defaultChecked />
												<label className="form-check-label mb-1px ps-1" htmlFor="customCheck2">integrate jquery autocomplete with ui</label>
											</div>
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="customCheck3" />
												<label className="form-check-label mb-1px ps-1" htmlFor="customCheck3">backend search return as json data</label>
											</div>
										</div>
									</div>
								</div>
							</div>
							<a href="#/" className="list-group-item list-group-item-action d-flex px-3 text-body">
								<div className="me-3">
									<i className="far fa-question-circle opacity-5 fa-fw fa-lg opacity-5"></i> 
								</div>
								<div className="flex-fill">
									<div className="fw-semibold">Investigate adding markdownlint</div>
									<div className="small opacity-75 mb-2">#29919 opened 9 days ago by xMediaKron</div>
									<div className="mb-1">
										<span className="badge bg-white bg-opacity-10 text-white text-opacity-75 border border-white me-2">build</span>
										<span className="badge bg-indigo bg-opacity-10 text-indigo border border-indigo">v5</span>
									</div>
								</div>
							</a>
							<a href="#/" className="list-group-item list-group-item-action d-flex px-3 text-body">
								<div className="me-3">
									<i className="far fa-question-circle text-muted fa-fw fa-lg opacity-5"></i> 
								</div>
								<div className="flex-fill">
									<div className="fw-semibold">Add a "Submit a Resource" form</div>
									<div className="small opacity-75 mb-2">#29916 opened 9 days ago by Wasbbok</div>
									<div className="mb-1 d-flex align-items-center">
										<span className="badge bg-success bg-opacity-10 text-success border border-success me-2">enhancement</span>
										<div className="widget-user-list">
											<div className="widget-user-list-item w-20px h-20px"><div className="widget-user-list-link w-20px h-20px"><img src="/img/user/user-1.jpg" alt="" /></div></div>
											<div className="widget-user-list-item w-20px h-20px"><div className="widget-user-list-link w-20px h-20px"><img src="/img/user/user-2.jpg" alt="" /></div></div>
											<div className="widget-user-list-item w-20px h-20px"><div className="widget-user-list-link w-20px h-20px"><img src="/img/user/user-3.jpg" alt="" /></div></div>
											<div className="widget-user-list-item w-20px h-20px"><div className="widget-user-list-link w-20px h-20px"><img src="/img/user/user-4.jpg" alt="" /></div></div>
											<div className="widget-user-list-item w-20px h-20px"><div className="widget-user-list-link w-20px h-20px"><img src="/img/user/user-5.jpg" alt="" /></div></div>
											<div className="widget-user-list-item w-20px h-20px"><div className="widget-user-list-link w-20px h-20px bg-white bg-opacity-15 text-white fs-9px fw-semibold">+2</div></div>
										</div>
									</div>
								</div>
							</a>
							<a href="#/" className="list-group-item list-group-item-action d-flex px-3 text-body">
								<div className="me-3">
									<i className="far fa-question-circle text-muted fa-fw fa-lg opacity-5"></i> 
								</div>
								<div className="flex-fill">
									<div className="fw-semibold">Custom control border color missing on focus</div>
									<div className="small opacity-75 mb-2">#29796 opened 29 days ago by mdo</div>
									<div className="mb-1">
										<span className="badge bg-pink bg-opacity-10 text-pink border border-pink">docs</span>
									</div>
								</div>
							</a>
							<a href="#/" className="list-group-item list-group-item-action d-flex px-3 text-body">
								<div className="me-3">
									<i className="far fa-question-circle text-muted fa-fw fa-lg opacity-5"></i> 
								</div>
								<div className="flex-fill">
									<div className="fw-semibold">New design for corporate page</div>
									<div className="small opacity-75 mb-2">#29919 opened 19 days ago by sean</div>
									<div className="mb-1">
										<span className="badge bg-white bg-opacity-10 text-white text-opacity-75 border border-white me-2">design</span>
										<span className="badge bg-primary bg-opacity-10 text-primary border border-primary me-2">v5</span>
									</div>
								</div>
							</a>
						</CardBody>
					</Card>
				</div>
				<div className="col-xl-4 col-lg-6">
					<Card className="mb-3">
						<CardHeader className="with-btn">
							IN PROGRESS (2)
							<CardHeaderBtn />
						</CardHeader>
						<CardBody className="list-group list-group-flush p-0">
							<div className="list-group-item d-flex px-3 text-body">
								<div className="me-3">
									<i className="fa fa-tools fa-fw fa-lg opacity-5"></i> 
								</div>
								<div className="flex-fill">
									<div className="fw-semibold">HTML5 flexbox old browser compatibility</div>
									<div className="small mb-2 opacity-75">#29982 handled by Sean</div>
									<div className="mb-1">
										<span className="badge bg-indigo bg-opacity-10 text-indigo border border-indigo me-2">enhancement</span>
									</div>
									<hr className="my-3" />
									<div className="d-flex align-items-center mb-2 small">
										<div className="fw-semibold me-2">
											Task (1/2)
										</div>
										<div className="flex-1">
											<a href="#/" className="text-body text-opacity-50" data-bs-toggle="collapse" data-bs-target="#inProgressBoard">
												<i className="bi bi-plus-square"></i>
											</a>
										</div>
										<div className="progress progress-xs w-100px me-2 h-4px">
											<div className="progress-bar progress-bar-striped bg-warning" style={{ width: '50%' }}></div>
										</div>
										<div>50%</div>
									</div>
									<div className="form-group mb-0 pb-1 fs-11px text-body text-opacity-75">
										<div className="collapse show" id="inProgressBoard">
											<div className="form-check mb-2px">
												<input type="checkbox" className="form-check-input" id="customCheck4" defaultChecked />
												<label className="form-check-label mb-1px ps-1" htmlFor="customCheck4">check all browser compatibility for HTML5 flexbox</label>
											</div>
											<div className="form-check mb-2px">
												<input type="checkbox" className="form-check-input" id="customCheck5" />
												<label className="form-check-label mb-1px ps-1" htmlFor="customCheck5">fallback integration by using other display property</label>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="list-group-item d-flex px-3 text-body">
								<div className="me-3">
									<i className="fa fa-bug text-danger fa-fw fa-lg"></i> 
								</div>
								<div className="flex-fill">
									<div className="fw-600 text-body">Mobile app autoclose on iOS</div>
									<div className="small mb-2 opacity-75">#29953 handled by Ken</div>
									<div className="mb-1">
										<span className="badge bg-white bg-opacity-10 text-white text-opacity-75 border border-white me-2">issue</span>
										<span className="badge bg-danger bg-opacity-10 text-danger border border-danger me-2">bug</span>
									</div>
									<hr className="my-3" />
									<div className="d-flex align-items-center mb-2 small">
										<div className="fw-semibold me-2">
											Task (0/1)
										</div>
										<div className="flex-1">
											<a href="#/" className="text-body text-opacity-50" data-bs-toggle="collapse" data-bs-target="#inProgress2Board">
												<i className="bi bi-plus-square"></i>
											</a>
										</div>
										<div className="progress progress-xs w-100px me-3 h-4px">
											<div className="progress-bar progress-bar-striped bg-danger" style={{ width: '5%'}}></div>
										</div>
										<div>0%</div>
									</div>
									<div className="form-group mb-0 pb-1 fs-11px text-body text-opacity-75">
										<div className="collapse show" id="inProgress2Board">
											<div className="form-check mb-2px">
												<input type="checkbox" className="form-check-input" id="customCheck6" />
												<label className="form-check-label mb-1px ps-1" htmlFor="customCheck6">debug and fix mobile auto close while using GPS issue</label>
											</div>
										</div>
									</div>
								</div>
							</div>
						</CardBody>
					</Card>
				</div>
				<div className="col-xl-4 col-lg-6">
					<Card className="mb-3">
						<CardHeader className="with-btn">
							DONE (1)
							<CardHeaderBtn />
						</CardHeader>
						<CardBody className="list-group list-group-flush p-0">
							<div className="list-group-item d-flex px-3 text-body">
								<div className="me-3">
									<i className="far fa-check-circle text-success fa-fw fa-lg"></i> 
								</div>
								<div className="flex-fill">
									<div className="fw-semibold">Angular version missing daterangepicker</div>
									<div className="small mb-2 opacity-75">#29930 closed yesterday by Sean</div>
									<div className="mb-1">
										<span className="badge bg-white bg-opacity-10 text-white text-opacity-75 border border-white me-2">build</span>
										<span className="badge bg-success bg-opacity-10 text-success border border-success me-2">feature</span>
									</div>
									<hr className="my-3" />
									<div className="d-flex align-items-center mb-2 small">
										<div className="fw-semibold me-2">
											Task (3/3)
										</div>
										<div className="flex-1">
											<a href="#/" className="text-body text-opacity-50" data-bs-toggle="collapse" data-bs-target="#completedBoard">
												<i className="bi bi-plus-square"></i>
											</a>
										</div>
										<div className="progress progress-xs w-100px me-3 h-4px">
											<div className="progress-bar progress-bar-striped bg-success" style={{ width: '100%'}}></div>
										</div>
										<div>100%</div>
									</div>
									<div className="form-group mb-0 pb-1 fs-11px text-body text-opacity-75">
										<div className="collapse show" id="completedBoard">
											<div className="form-check mb-2px">
												<input type="checkbox" className="form-check-input" id="customCheck7" defaultChecked />
												<label className="form-check-label pt-1px" htmlFor="customCheck7">install angular-daterangepicker</label>
											</div>
											<div className="form-check mb-2px">
												<input type="checkbox" className="form-check-input" id="customCheck8" defaultChecked />
												<label className="form-check-label pt-1px" htmlFor="customCheck8">customize ui with scss</label>
											</div>
											<div className="form-check mb-2px">
												<input type="checkbox" className="form-check-input" id="customCheck9" defaultChecked />
												<label className="form-check-label pt-1px" htmlFor="customCheck9">backend integration for data filter with daterange input</label>
											</div>
										</div>
									</div>
								</div>
							</div>
						</CardBody>
					</Card>
				</div>
			</div>
		
			<div className="modal fade" id="modalAddTask">
				<div className="modal-dialog">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title">Add Task</h5>
							<button type="button" className="btn-close" data-bs-dismiss="modal"></button>
						</div>
						<div className="modal-body">
							<div className="mb-3">
								<label className="form-label">Title</label>
								<input type="text" className="form-control" placeholder="e.g Feature enhancement" />
							</div>
							<div className="mb-3">
								<label className="form-label">Status</label>
								<select className="form-select">
									<option defaultValue="">To Do</option>
									<option defaultValue="">In Progress</option>
									<option defaultValue="">Done</option>
								</select>
							</div>
							<div className="mb-3">
								<label className="form-label">Tags</label>
								<TagsInput defaultValue={tags} name="tags" placeHolder="enter tags" />
							</div>
							<div className="form-group">
								<label>Description</label>
								<textarea className="form-control" rows="10"></textarea>
							</div>
						</div>
						<div className="modal-footer">
							<a href="#/" className="btn btn-outline-default" data-bs-dismiss="modal">Cancel</a>
							<button type="button" className="btn btn-outline-theme">Create</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default PagesScrumBoard;